import { i18nspectPostProcessor } from '@i18nspect/interceptor';
// @ts-expect-error @jupiter/plugin-runtime is inject by main app
import { i18n as JupiterI18n } from '@jupiter/plugin-runtime/i18n';
import btm from '@i18n-ecom/universal-tracker';
import { LangMap } from '../../../constants';
import { sendTeaLog } from '../tea';

const useOecProductCategoryStarling = (() => {
  try {
    // @ts-expect-error injected from global vars
    const value = USE_OEC_PRODUCT_CATEGORY_STARLING;
    if (typeof value === 'boolean') {
      return value;
    }
  } catch (_) {}

  return true;
})();

export const i18nspect = i18nspectPostProcessor({
  enable: true,
  options: {
    i18n: JupiterI18n,
    starling: {
      projects: [
        {
          apiKey: 'a66ca7a027b311ebbb80cf5f695598e8',
          projectName: 'i18n_ecom_alliance',
          namespace: ['web'],
        },
        ...(useOecProductCategoryStarling
          ? [
              {
                apiKey: 'd6d0a9902ecb11eb8cdea93eab94775b',
                projectName: 'oec_product',
                namespace: ['category'],
              },
            ]
          : []),
      ],
    },
    languages: Object.values(LangMap),
    btm,
    tea: (name, params) => {
      sendTeaLog(name, params);
    },
    collectSampleRatio: 0.1,
  },
});
